/**
 * The shared class vocabulary (CLAUDE.md: repeated class strings factored
 * into one source of truth). Values are the accepted artboards' measures:
 * 12px cards, 8px controls, 6px glyphs, 44px primary actions.
 */
export const CARD =
  'overflow-hidden rounded-card border border-line bg-surface shadow-card';
export const CARD_LIFT =
  'overflow-hidden rounded-card border border-line bg-surface shadow-lift';
export const CARD_FOOT = 'border-t border-line bg-sunk px-6 py-3 text-[12px] text-mute';
export const SECTION_LABEL = 'text-[12px] font-semibold tracking-[0.04em] text-mute';
export const TABLE_HEAD = 'text-[12px] font-semibold tracking-[0.04em] text-mute';
export const ROW = 'border-t border-line';
export const MONO = 'font-mono tabular-nums';
export const MUTE = 'text-mute';
export const LINK = 'font-semibold text-accent hover:text-ink';
export const BACK_LINK =
  'inline-flex w-max items-center gap-2 text-[13px] text-mute hover:text-ink';

export const INPUT =
  'h-[46px] w-full rounded-btn border border-line bg-surface px-3.5 text-[15px] text-ink placeholder:text-mute/70 focus:border-ink';
export const LABEL = 'text-[13px] font-semibold tracking-[0.02em] text-mute';

export type ButtonVariant = 'primary' | 'secondary' | 'ink' | 'quiet' | 'danger';
export type ButtonSize = 'md' | 'sm';

const BUTTON_BASE =
  'inline-flex shrink-0 cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-btn font-semibold transition-colors disabled:cursor-default disabled:opacity-60';

const BUTTON_VARIANT: Record<ButtonVariant, string> = {
  primary: 'bg-accent text-accent-ink shadow-btn hover:bg-[#0a4f65]',
  secondary: 'border border-line bg-surface text-ink shadow-quiet hover:bg-sunk',
  ink: 'bg-ink text-surface hover:bg-[#232b28]',
  quiet: 'text-mute hover:text-ink',
  danger: 'border border-line bg-surface text-crit hover:bg-crit-bg',
};

const BUTTON_SIZE: Record<ButtonSize, string> = {
  md: 'h-11 px-5 text-[14px]',
  sm: 'h-9 px-3.5 text-[13px]',
};

export function buttonClass(
  variant: ButtonVariant = 'secondary',
  size: ButtonSize = 'md',
): string {
  return `${BUTTON_BASE} ${BUTTON_VARIANT[variant]} ${BUTTON_SIZE[size]}`;
}

export function cx(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ');
}
